
import './App.css';
import * as React from 'react';
import {Component} from "react";
import {HashRouter, Route, Switch} from "react-router-dom";

import {Navbar} from './components/navbar/navbar';
import {AboutUS} from "./components/aboutus/aboutus";
import {Home} from "./components/home/home";
import {Process} from "./components/process/process";
import {Team} from "./components/team/team";
import {ContactUs} from "./components/contactus/contactus";
import {ProcessOne} from "./components/processes/processOne";
import {ProcessTwo} from "./components/processes/processTwo";
import {ProcessThree} from "./components/processes/processThree";
import {ProcessFour} from "./components/processes/processFour";
import {ProcessFive} from "./components/processes/processFive";
import {InProgress} from "./components/inProgress/inProgress";
import {Something} from "./components/inProgress/something";

class App extends Component {
    render() {
        return (
            <div className={'app'}>
                <HashRouter>
                    <Navbar/>
                    <Switch>
                        <Route exact path={'/'} component={Home}/>
                        <Route exact path={'/om_oss'} component={AboutUS}/>
                        <Route exact path={'/prosess'} component={Process}/>
                        <Route exact path={'/team'} component={Team}/>
                        <Route exact path={'/kontakt_oss'} component={ContactUs}/>
                        {/*<Route exact path={'/prosess/prosess_1'} component={ProcessOne}/>
                        <Route exact path={'/prosess/prosess_2'} component={ProcessTwo}/>
                        <Route exact path={'/prosess/prosess_3'} component={ProcessThree}/>
                        <Route exact path={'/prosess/prosess_4'} component={ProcessFour}/>
                        <Route exact path={'/prosess/prosess_5'} component={ProcessFive}/>*/}
                        {/*
                        <Route exact path={'/'} component={InProgress}/>
                        <Route exact path={'/something'} component={Something}/>
                        */}
                    </Switch>
                </HashRouter>
            </div>
        )
    }
}

export default App;
